export const BY_TIME = 'BY_TIME';
export const BY_HOUR_METER = 'BY_HOUR_METER';
